import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
type ReplyTicketDTO = {
    message: string,
    attachments?:string[]
};

type TicketResponse  = ApiError;

export const ReplyTicket = (data: ReplyTicketDTO, ticketId:string): Promise<TicketResponse> => {
    return axios.patch(`/support/reply-ticket/${ticketId}`, data)
        .then(response => response.data as TicketResponse);
};